import React from 'react'
import Select from '../Select'
import classes from './SchoolNoteSchoolForm.module.sass'

const SchoolEdit = ({
  school: {
    districtId,
    address,
    phone,
    principal,
    prinEmail,
    secretary,
    sec1Email
  },
  onChange,
  districts,
}) => (
  <>
    <label>
      District:
      <Select name="districtId" val={districtId} onChange={onChange}>
        {districts.map((district) => (
          <option key={district.id} value={district.id}>{district.name}</option>
        ))}
      </Select>
    </label>
    <label>
      Address:
      <input className={classes.input} onChange={onChange} name="address" value={address} />
    </label>
    <label>
      Phone:
      <input className={classes.input} onChange={onChange} name="phone" value={phone} />
    </label>
    <div>
      <h6 className={classes.h6}>Principal</h6>
      <label>
        Name:
        <input className={classes.input} onChange={onChange} name="principal" value={principal} />
      </label>
      <label>
        Email:
        <input className={classes.input} onChange={onChange} name="prinEmail" value={prinEmail} />
      </label>
    </div>
    <div>
      <h6 className={classes.h6}>Secretary</h6>
      <label>
        Name:
        <input className={classes.input} onChange={onChange} name="secretary" value={secretary} />
      </label>
      <label>
        Email:
        <input className={classes.input} onChange={onChange} name="sec1Email" value={sec1Email} />
      </label>
    </div>
  </>
)

export default SchoolEdit
